import $ from 'jquery';
import _ from 'lodash';
import module from 'module';

const templateUrl = require('./calculate-auction-price.template.html');
const auctionTagPath = `/dashboard/appraisals/auction-tag`;

class CalculateAuctionPrice {
  constructor($routeParams, http, pawnStatusMapper, pawnItemTypeCache, $location, reportModal,
              branchService, pawnAuctionCache, pawnMetalDescriptionService,
              modalInfo, command, pawnItemCache, pawnCache, popup) {
    this.$routeParams = $routeParams;
    this.http = http;
    this.pawnStatusMapper = pawnStatusMapper;
    this.pawnItemTypeCache = pawnItemTypeCache;
    this.$location = $location;
    this.reportModal = reportModal;
    this.branchService = branchService;
    this.pawnAuctionCache = pawnAuctionCache;
    this.pawnMetalDescriptionService = pawnMetalDescriptionService;
    this.modalInfo = modalInfo;
    this.command = command;
    this.pawnItemCache = pawnItemCache;
    this.pawnCache = pawnCache;
    this.popup = popup;
  }

  async $onInit() {
    this.selectedIds = this.$routeParams.selectedIds.map(Number);
    this.selectedBranchId = Number(this.$routeParams.selectedBranchId);

    this.pawnItemTypes = [];
    this.pawnItems = [];

    this.branchService.toObservable().subscribe(branches => {
      this.branches = branches;
    });

    this.pawnAuctionCache.systemAuctions().toObservable().subscribe(auctions => {
      this.auctions = auctions;
    });

    // Read pawn item types
    this.pawnItemTypeCache.toObservable().subscribe(itemTypes => {
      this.pawnItemTypes = itemTypes;
    });

    await this.fetchPawnItemsWithCalculatedAuctionPrices();
  }

  async fetchPawnItemsWithCalculatedAuctionPrices() {
    if (!this.selectedIds || this.selectedIds.length === 0) {
      return;
    }

    await this.http.get(`/products/pawns/items-with-calculated-auction-price?ids=${this.selectedIds}`)
      .success((response) => {
        this.pawnItems = response;

        // For each pawn item prepare item details
        if (this.pawnItems && this.pawnItems.length > 0) {
          _.forEach(this.pawnItems, (obj) => {
            // calculate box number
            obj.item.boxNumber = obj.item.withdrawBox ? obj.item.withdrawBox.branchId + '-'
              + obj.item.withdrawBox.boxNumber : null;

            // Extend item with category/type/subtype labels
            Object.assign(obj.item, {categoryLabel: this.getTypeLabel(obj.item.categoryId)});
            Object.assign(obj.item, {typeLabel: this.getTypeLabel(obj.item.typeId)});
            Object.assign(obj.item, {subtypeLabel: this.getTypeLabel(obj.item.subtypeId)});
            // Extend item with details pane data
            if (!obj.pawn) {
              Object.assign(obj.pawn, {
                auctionDate: '-',
                expirationDate: '-',
                productNumber: '-'
              });
            }
          })
        }
      });
  }

  getTypeLabel(typeId) {
    let type = _.find(this.pawnItemTypes, {id: typeId});
    return type && type.name ? type.name : '-';
  };

  generateAuctionTag() {
    this.$location.path(auctionTagPath).search({selectedIds : this.selectedIds});
  }

  generateAuctionReport() {
    let params = {
      ids: this.selectedIds
    };
    let reportName = 'AuctionItemsReport';
    this.reportModal.display({
      params: params,
      reportCode: reportName,
      hideXls: true
    });
  }

  getAuctionNamesForCurrentBranch() {
    const auctions = _.filter(this.auctions, a => this.selectedIds.includes(a.id))
    return auctions != null ? auctions.map(a => a.name).join(", ") : null;
  }

  withdrawAction() {
    const branch = _.find(this.branches, {id: this.selectedBranchId}, 0);
    const branchName = branch != null ? branch.name : null;
    const auctionsName = this.getAuctionNamesForCurrentBranch();

    const content = this.pawnMetalDescriptionService.buildSelectedItemsInfo(
      branchName,
      auctionsName,
      this.selectedIds
    );

    const buttons = [{
      text: 'Withdraw',
      action: async () => {
        this.modalInfo.closeModalWithBackdrop();

        const res = await this.command.execute('WithdrawPawnItem', {
          itemIds: this.selectedIds,
          allowAuctionedPawns: true
        }).toPromise();
        if (!res || res.approvalRequired) {
          return;
        }

        this.pawnItemCache.evict();
        this.pawnCache.evict();

        this.popup({
          text: `Created box number: ${branch.id + '-' + res.output.id}`,
          callback: () => {
            this.$location.path(`/dashboard/appraisals`);
          }
        });
      },
      bclass: 'btn btn-primary'
    }];

    this.modalInfo.display(
      content,
      "Pawned items selected for withdraw",
      `Do you want to withdraw ${this.selectedIds.length} items to head office?`,
      buttons);
  };

  goBack() {
    window.history.back();
  }

  $onDestroy() {
    if (this.selectedIds && this.$location.path() !== auctionTagPath) {
      this.$location.search({});
    }
  }
}

module.component('calculateAuctionPrice', {
  templateUrl: templateUrl,
  controller: CalculateAuctionPrice
});